import { Label, useTheme, type Theme } from '@shared/components';

function getRegistrationTypeStyles(theme: Theme) {
  return {
    colors: {
      IH: 'hsla(20, 90%, 37%, 1)',
      PUB: theme.palette.success.main,
    },
    backgroundColors: {
      IH: 'hsla(43, 96%, 89%, 1)',
      PUB: theme.palette.success.lighter,
    },
    borderColors: {
      IH: 'hsla(32, 92%, 50%, 1)',
      PUB: theme.palette.success.main,
    },
  };
}

const REGISTRATION_TYPE_SHORT_TEXT = {
  IH: 'IH',
  PUB: 'PUB',
};

const REGISTRATION_TYPE_FULL_TEXT = {
  IH: 'In-House',
  PUB: 'Public',
};

const REGISTRATION_TYPE_COLOR = {
  IH: 'primary',
  PUB: 'success',
} as const;

export type RegistrationType = 'IH' | 'PUB';

export interface RegistrationTypeLabelProps {
  type: RegistrationType;
  variant?: 'short' | 'full';
}

export default function RegistrationTypeLabel(props: Readonly<RegistrationTypeLabelProps>) {
  const { type, variant = 'short' } = props;

  const theme = useTheme();

  const { backgroundColors, borderColors, colors } = getRegistrationTypeStyles(theme);

  return (
    <Label
      size='small'
      variant='outlined'
      borderType='round'
      color={REGISTRATION_TYPE_COLOR[type]}
      sx={{
        borderColor: borderColors[type],
        bgcolor: backgroundColors[type],
        color: colors[type],
        width: variant === 'short' ? '40px' : 'auto',
        height: 'fit-content',
      }}
    >
      {variant === 'short' ? REGISTRATION_TYPE_SHORT_TEXT[type] : REGISTRATION_TYPE_FULL_TEXT[type]}
    </Label>
  );
}
